module.exports = __webpack_public_path__ + "static/img/18.ff53947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/18.jpg
// module id = upOt
// module chunks = 0